export function clamp(n: number, min: number, max: number): number {
  return Math.min(Math.max(n, min), max);
}

export function lerp(start: number, end: number, t: number): number {
  const clampedT = clamp(t, 0, 1);
  return (1 - clampedT) * start + clampedT * end;
}

export function toNearest(n: number, frac: number): number {
  return Math.ceil(n / frac) * frac;
}
